import React from 'react';
import styles from './ForgotPassword.module.css';
import globalStyles from '../../styles/globalStyles.module.css';
import forgotPassword from '../../assets/images/forgotPassword.svg';
import {useNavigate} from 'react-router-dom';
import {endpoints} from '../../../api/endpoints';
import {postFetcher} from '../../../api/fetchers';
import { toast } from 'react-toastify';
import { useLanguage } from '../../context/LanguageContext';

const ForgotPassword: React.FC = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const email = (e.target as HTMLFormElement).elements.namedItem('email') as HTMLInputElement;

        const result = await postFetcher(endpoints.auth.resetUserPassword, {
            arg: {
                email: email.value,
            },
        });

        if (result) {
            toast.success(t('toastMessage', 'rate25'));
            navigate('/password-verification', {state: {formData: {email: email.value}}});
        } else {
            toast.error('Error');
        }
    };

    return (
        <div className="flex flex-col md:flex-row min-h-screen md:h-screen w-screen bg-primary-color">
            {/* LEFT SIDE START */}
            <div className={`w-full md:w-1/2 flex items-center justify-center ${globalStyles.leftSide} hidden md:flex`}>
                <img src={forgotPassword} alt="Left" className="object-cover"/>
            </div>
            {/* LEFT SIDE END */}

            {/* RIGHT SIDE START */}
            <div
                className={`w-full md:w-1/2 md:h-full bg-white flex items-center justify-center ${globalStyles.rightSide}`}>
                <div className="w-full max-w-md p-8 space-y-6">
                    {/* FORGOT PASSWORD FORM */}
                    <h1 className={`w-full text-4xl text-center text-color-pink mb-10 ${globalStyles['poppins-regular']}`}>{t('fargotPassword', 'title')}</h1>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {/* EMAIL */}
                        <div>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="E-mail"
                                className={`block w-full px-3 py-2 mt-1 bg-transparent border-b-2 border-color-pink placeholder-color-pink placeholder:font-bold focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                                required
                            />
                        </div>

                        {/* SUBMIT BUTTON */}
                        <button
                            type="submit"
                            className="w-full px-4 py-2 text-white bg-primary-color font-bold rounded-md hover:bg-hover-color hover:text-color-pink focus:ring-2 focus:ring-pink-500"
                        >
                            {t('fargotPassword', 'button')}
                        </button>
                    </form>
                </div>
            </div>
            {/* RIGHT SIDE END */}
        </div>
    );
}

export default ForgotPassword;
